<template>
  <div class="list-container">
    <div >
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">外包商</span>
            <el-input
                v-model="listQuery.outsourceCompany"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">发票号码</span>
            <el-input
              v-model="listQuery.invoiceNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
           <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.companyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
                v-model="listQuery.businessNo"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
                v-model="listQuery.businessName"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
                v-model="listQuery.businessModel"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>

          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">登记时间</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">付款时间</span>
            <el-date-picker
              v-model="listQuery.payStartTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.payEndTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <!-- <div class="filter-box">
            <span class="label">登记时间</span>
            <el-date-picker
              v-model="listQuery.time"
              type="daterange"
              range-separator="～"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            />
          </div>
          <div class="filter-box">
            <span class="label">付款时间</span>
            <el-date-picker
              v-model="listQuery.payTime"
              type="daterange"
              range-separator="～"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            />
          </div> -->
          <div class="filter-box">
            <el-radio-group v-model="listQuery.status" @change="handleFilter">
              <el-radio label="4" >待付款</el-radio>
              <el-radio label="6" >已付款</el-radio>
              <el-radio label="7" >退款中</el-radio>
              <el-radio label="8" >已退款</el-radio>
              <el-radio label="" >全部</el-radio>
            </el-radio-group>
          </div>
        </template>
          <div class="filter-box">
            <el-button
              v-waves
              class="filter-item "
              type="primary"
              :size="t('table.btnSize')"
              @click="handleFilter"
            >
              {{ t("table.search") }}
            </el-button>
            <el-button
              v-permission="{ pkey: `${permissionName}_ADD` }"
              class="filter-item"
              type="primary"
              :size="t('table.btnSize')"
              @click="handleCommand('add')"
            >
              {{ t("table.add") }}
            </el-button>
            <el-button
              v-permission="{ pkey: `${permissionName}_PAYOK` }"
              class="filter-item"
              type="primary"
              :size="t('table.btnSize')"
             @click="handleCommand('batch-payOk')"
            >
              批量付款
            </el-button>
            <el-button
              v-permission="{ pkey: `${permissionName}_PAYOK` }"
              class="filter-item"
              type="warning"
              :size="t('table.btnSize')"
             @click="handleCommand('batch-refundOk')"
            >
              批量退款确认
            </el-button>
            <el-button
              v-waves
              class="filter-item"
              :size="t('table.btnSize')"
              @click="handleReset"
            >
              {{ t("table.reset") }}
            </el-button>
            <el-button
              v-waves
              class="filter-item"
              :size="t('table.btnSize')"
              @click="isFilterCollapse = !isFilterCollapse"
            >
              {{ isFilterCollapse ? '展开' : '收起' }}
            </el-button>
            <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
                <i class="icon-tubiao-27 iconfont"/>
          </span>
            <span class="svg-icon cursor" @click="handleCommand('column')">
                <i class="icon-tubiao-28 iconfont"/>
          </span>
           <span class="ml-10 filter-mark">
             <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">待付款且业务未收款</span></span>
             <span class="status-item"><span class="status-square" style="background-color: blue;"></span><span class="status-text">待付款且业务已收款</span></span>
           </span>
          </div>
      </div>
      <TableList
        ref="tableDataRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :tableRowClassName="tableRowClassName"
        :isShowPagination="false"
        :showSelection="true"
        :showSummary="true"
        :handleDefaultWidth="160"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-if="scope.row.status === '审批通过-待付款' || scope.row.status === '无需审批-待付款'"
            v-permission="{ pkey: `${permissionName}_PAYOK` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            :disabled="!!payBlockedReason(scope.row)"
            :title="payBlockedReason(scope.row)"
            @click="handleCommand('PAYOK', scope.row)"
          >
            付款
          </el-link>
          <el-link
            v-if="Number(scope.row.paid || 0) > 0 || scope.row.status === '完成' || scope.row.status === '退款中'"
            v-permission="{ pkey: `${permissionName}_PAYOK` }"
            href="javascript:void(0);"
            class="mr-10"
            type="warning"
            @click="handleCommand('REFUNDOK', scope.row)"
          >
            {{ scope.row.status === '退款中' ? '退款确认' : '退款' }}
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_PAID_RECORD` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('paid-record', scope.row)"
          >
           明细
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <el-dialog
      v-model="dialogFormVisible"
      :title="dialogTitle"
      width="80%"
    >
      <MiniBusinessList :businessList="selectionRowList" ref="miniBusinessList">
        <template v-slot:before>
          <el-table-column prop="no" label="编号" show-overflow-tooltip width="120"/>
          <el-table-column prop="name" label="名称" show-overflow-tooltip width="100"/>
          <el-table-column prop="brand" label="品牌" show-overflow-tooltip/>
          <el-table-column prop="fee" label="总费用" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.fee)}}
            </template>
          </el-table-column>
          <el-table-column prop="paid" label="已付费用" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.paid) }}
            </template>
          </el-table-column>
          <el-table-column prop="paidAmount" :label="currentCommand === 'refund' ? '本次退款' : '费用'" show-overflow-tooltip align="right" min-width="160">
            <template #default="{ row }">
              <el-input-number
                v-model="row.paidAmount"
                type="number"
                :min="0.01"
                :max="currentCommand === 'refund' ? Number(row.paid) : Number(row.fee - row.paid)"
                :precision="2"
                controls-position="right"
                @change="handleFeeInput(row)"
                @input="handleFeeInput(row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="remainAmount" :label="currentCommand === 'refund' ? '退后净付' : '待付费用'" show-overflow-tooltip align="right" width="100">
            <template #default="{ row }">
              {{ $currency(row.remainAmount)}}
            </template>
          </el-table-column>
        </template>
        <template v-slot:after>
          <el-table-column prop="businessAmount" label="数量" width="60" />
          <el-table-column prop="salesMan" label="业务代表" width="100" show-overflow-tooltip/>
          <el-table-column prop="customerCompany" label="客户公司" width="100" show-overflow-tooltip/>
          <el-table-column prop="ticketCompany" label="所属公司" width="100" show-overflow-tooltip/>
          <el-table-column prop="invoiceStatus" label="开票状态" width="100" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.invoiceStatus }}
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="60" />
          <el-table-column prop="model" label="型号" show-overflow-tooltip/>
          <el-table-column prop="serial" label="序列号" show-overflow-tooltip/>
        </template>
      </MiniBusinessList>
      <div class="form-title mt-30 mb-10">
        <span class="label" :class="currentCommand === 'refund' ? 'yellow' : 'green'">{{ currentCommand === 'refund' ? '退' : '付' }}</span>
        <span class="left">{{ currentCommand === 'refund' ? '退款确认' : '付款确认' }}</span>
      </div>
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
        >
          <div class="underlineForm">
            <el-form-item :label="currentCommand === 'refund' ? '收款账户' : '付款账户'" prop="paymentAccountId" >
              <el-select :filterable="true" v-model="formData.paymentAccountId" class="filter-item" placeholder="输入关键字搜索" clearable>
                <el-option
                  v-for="item in accountOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="currentCommand === 'refund' ? '退款时间' : '付款时间'" prop="paymentTime">
              <el-date-picker
                v-model="formData.paymentTime"
                type="date"
                placeholder=" "
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                :size="t('table.btnSize')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="currentCommand === 'refund' ? '退款备注' : '付款备注'" prop="paymentMark" class="fullWidth">
              <el-input
                v-model="formData.paymentMark"
                placeholder=" "
                type="textarea"
              />
            </el-form-item>
          </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="paidRecordVisible"
      title="明细"
      width="60%"
      close-on-click-modal
    >
      <ChargeFee :id="activeId" api="outsourceFee" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="paidRecordVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, unref } from 'vue'
import { cloneDeep } from 'lodash'
import { ElMessage, ElForm } from 'element-plus'
import { paymentConfirm, refundConfirm, getOutsourceFeePage } from '@/apis/OutsourceFee'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/outsourceCompany/accountInfo/FieldFrom'
import { TableField } from './FieldTable'
import { useI18n } from 'vue-i18n'
import { Today, pageVo, pageSizes, defaultDate } from '@/utils/index'
import MiniBusinessList from '@/views/business/businessList/MiniBusinessList.vue'
import ChargeFee from '@/views/financial/chargeFee/Index.vue'
import $currency from 'currency.js'

export default defineComponent({
  name: 'Outsourcefeefin',
  methods: { $currency },
  components: {
    // FormComponent,
    TableList,
    // AccountPreview,
    MiniBusinessList,
    ChargeFee
  },
  setup() {
    const { t } = useI18n()
    const tableDataRef = ref(null)
    const miniBusinessList = ref(null)
    const dataForm = ref(ElForm)
    const dataMap = reactive({
      TableName: TableName.TABLE_FINANCIAL_OUTSOURCE_FEE,
      permissionName: permissionName.FINANCIAL_OUTSOURCE_FEE,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,
      isFilterCollapse: false,

      activeId: 0,
      activeRow: null,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessModel: undefined,
        outsourceCompany: undefined,
        salesManId: undefined,
        invoiceStatus: undefined,
        status: '4',
        startTime: '',
        endTime: '',
        time: [],
        payTime: [],
        payStartTime: '',
        payEndTime: '',
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      paidRecordVisible: false,

      salesManOption: [],
      ReviewStatusOption: [],
      UserPayTypeOption: [],
      submitLoading: false,
      accountOption: [],
      selectionArray: [],
      selectionRowList: [],
      dialogTitle: '付款确认',
      currentCommand: '',
      formData: {
        paymentAccountId: '',
        paymentTime: Today,
        paymentMark: ''
      },
      rules: {
        paymentAccountId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        paymentTime: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      statusOption: [
        {
          id: 4,
          name: '待付款'
        }, {
          id: 6,
          name: '已付款'
        }
      ],
      payBlockedReason(row: any) {
        if (row?.business?.status === '已取消') {
          return `业务编号:${row.businessNo}已取消，不允许付款外包费`
        }
        if (row?.business?.modify === 2) {
          return `业务编号:${row.businessNo}正在申请取消，请审批完成后再付款`
        }
        return ''
      },
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'PAYOK':
          case 'REFUNDOK':
          case 'batch-payOk':
          case 'batch-refundOk':
            {
              dataMap.currentCommand = command.toLowerCase().includes('refund') ? 'refund' : 'pay'
              dataMap.dialogTitle = dataMap.currentCommand === 'refund' ? '退款确认' : '付款确认'
              dataMap.activeId = val ? val.id : ''
              dataMap.formData = {
                paymentAccountId: '',
                paymentTime: Today,
                paymentMark: ''
              }
              dataMap.selectionRowList = val ? [val] : dataMap.selectionArray

              if (!dataMap.selectionRowList.length) {
                return ElMessage.error({
                  message: '请选择数据',
                  duration: 1000
                })
              }

              if (dataMap.currentCommand === 'pay') {
                const reasons = dataMap.selectionRowList
                  .map((row: any) => dataMap.payBlockedReason(row))
                  .filter((reason: string, index: number, all: string[]) => reason && all.indexOf(reason) === index)
                if (reasons.length) {
                  return ElMessage.error({
                    message: reasons.join('；'),
                    duration: 3000
                  })
                }
              }

              // 外包商
              const firstItem = dataMap.selectionRowList[0]
              const sameFiled = [{ key: 'outsourceCompany', name: '外包商' }]
              for (let i = 0; i < dataMap.selectionRowList.length; i++) {
                const item = dataMap.selectionRowList[i]
                for (let j = 0; j < sameFiled.length; j++) {
                  const kk = sameFiled[j]
                  if (item[kk.key] !== firstItem[kk.key]) {
                    return ElMessage.error({
                      message: `请选择同一个${kk.name}业务`,
                      duration: 1000
                    })
                  }
                }
                if (dataMap.currentCommand === 'refund' && Number(item.paid || 0) <= 0 && item.status !== '完成' && item.status !== '退款中') {
                  return ElMessage.error({
                    message: '所选记录包含无可退金额的外包费',
                    duration: 1500
                  })
                }
              }

              const businessIds = dataMap.selectionRowList.map((kk: any) => kk.id)
              getUrlList(`outsourceFee/actions/payments?ids=${businessIds}`).then((result: any) => {
                dataMap.selectionRowList = result
                  ? result.map((item: any) => {
                    const paid = Number(item.paid || 0)
                    const applyRefund = Number(item.refundApplyAmount || 0)
                    const paidAmount = dataMap.currentCommand === 'refund'
                      ? (applyRefund > 0 && applyRefund <= paid ? applyRefund : paid)
                      : Number((Number(item.fee || 0) - paid).toFixed(2))
                    const remainAmount = dataMap.currentCommand === 'refund'
                      ? Number((paid - paidAmount).toFixed(2))
                      : 0
                    return {
                      ...item.business,
                      fee: item.fee,
                      accountAlias: item.account?.alias,
                      paid,
                      paidAmount,
                      remainAmount,
                      outsourceId: item.id
                    }
                  })
                  : []
                dataMap.dialogFormVisible = true
              })
              getUrlList('paymentAccount/dropdown').then((res: any) => {
                dataMap.accountOption = res || []
              })
            }
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'paid-record':
            dataMap.activeId = val.id
            dataMap.paidRecordVisible = true
            break
        }
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getOutsourceFeePage({ ...dataMap.listQuery, pageType: 3 }).then((res: any) => {
          const list = res.data
            ? res.data.map((item: any) => {
              return {
                ...item,
                customerCompany: item.business.customerCompany,
                ticketCompany: item.business.ticketCompany,
                businessNo: item.business.no,
                businessName: item.business.name,
                businessBrand: item.business.brand,
                businessAmount: item.business.amount,
                businessModel: item.business.model,
                businessSerial: item.business.serial,
                businessUnit: item.business.unit,
                accountAlias: item.account?.alias,
                ticketAmount: item.amount,
                amount: item.business.amount,
                orderTaxRate: item.business.orderTaxRate,
                orderFee: item.business.orderFee
              }
            })
            : []

          // 根据颜色逻辑进行排序：红色(Priority 1) > 蓝色(Priority 2) > 黑色(Priority 3)
          dataMap.list = list.sort((a: any, b: any) => {
            const getPriority = (row: any) => {
              // 状态匹配字符串名称
              const isUnpaid = row.status === '审批通过-待付款' || row.status === '无需审批-待付款'
              if (!isUnpaid) return 3 // 黑色 (已处理/完成/退款等)

              // 收款状态匹配字符串名称
              const rs = row.business?.receivedStatus
              if (rs === '未收款' || rs === '部分收款') return 1 // 红色
              if (rs === '已收款' || rs === '无需收款') return 2 // 蓝色
              return 3 // 兜底黑色
            }

            const pA = getPriority(a)
            const pB = getPriority(b)

            if (pA !== pB) return pA - pB
            return b.id - a.id // 同优先级按ID降序
          })

          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessModel: undefined,
          outsourceCompany: undefined,
          salesManId: undefined,
          invoiceStatus: undefined,
          startTime: defaultDate[0],
          status: '4',
          endTime: defaultDate[1],
          time: [],
          payTime: [],
          payStartTime: '',
          payEndTime: '',
          ...pageVo

        }
        dataMap.handleFilter()
      },
      handleFilter() {
        // const { time = [], payTime = [] } = dataMap.listQuery
        // dataMap.listQuery.startTime = time ? time[0] : ''
        // dataMap.listQuery.endTime = time ? time[1] : ''
        // dataMap.listQuery.payStartTime = payTime ? payTime[0] : ''
        // dataMap.listQuery.payEndTime = payTime ? payTime[1] : ''
        dataMap.getList()
      },

      handlePayOk(row: any) {
        dataMap.activeId = row.id
        dataMap.activeRow = row
        dataMap.dialogFormVisible = true
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      handleCancle() {
        dataMap.dialogFormVisible = true
      },
      async handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const businessList = (miniBusinessList.value as any).businessList
              const params = {
                accountId: dataMap.formData.paymentAccountId,
                date: dataMap.formData.paymentTime,
                paymentMark: dataMap.formData.paymentMark,
                payments: businessList.map((kk: any) => {
                  return {
                    id: kk.outsourceId,
                    amount: kk.paidAmount
                  }
                })
              }
              const api = dataMap.currentCommand === 'refund' ? refundConfirm : paymentConfirm
              await api(params)
              dataMap.dialogFormVisible = false
              dataMap.getList()
              ElMessage({
                message: '提交成功',
                type: 'success',
                duration: 1000
              })
            } catch (err: any) {
              console.log(err)
            }
          }
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      tableRowClassName({ row }: any) {
        // 已经付了外包费黑色 (DONE=6, REFUNDING=7, REFUNDED=8)
        // 未付外包费 (ADOPT=4, AUTO=5) 没收到款 红色
        // 未付外包费 (ADOPT=4, AUTO=5) 收到款 蓝色
        const isUnpaid = row?.status === '审批通过-待付款' || row?.status === '无需审批-待付款'
        if (!isUnpaid) {
          return ''
        }
        if (row?.business?.receivedStatus === '已收款') {
          return 'row-blue'
        }
        if (row?.business?.receivedStatus === '未收款' || row?.business?.receivedStatus === '部分收款') {
          return 'row-red'
        }
        return ''
      },
      handleFeeInput(item: any) {
        if (dataMap.currentCommand === 'refund') {
          item.remainAmount = Number((Number(item.paid || 0) - Number(item.paidAmount || 0)).toFixed(2))
        } else {
          item.remainAmount = Number((Number(item.fee || 0) - Number(item.paid || 0) - Number(item.paidAmount || 0)).toFixed(2))
        }
        item.paidAmount = Number(item.paidAmount)
      }
    })
    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.listQuery.status = '4'
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap), tableDataRef, miniBusinessList, dataForm }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
